import { logAndylitics, log, logAPI } from "./andyliticsApi";
import * as tools from "../helpers/Tools";

const BASE_URL = typeof window !== 'undefined' ? window.serverData.data.phyndApibaseUrl : '';
const CLIENT_ID = "MyBSWHealth.Web";


/**
 * Phynd v2 GetLocations.
 * 
 * @param {any} searchModel Search parameters; property names must match the phynd api.
 * @returns {Promise} location search results.
 */
export const getLocations = (searchModel) => {
    const queryString = [];
    for (var property in searchModel) {
        queryString.push(`${property}=${encodeURIComponent(searchModel[property])}`);
    }

    // const fullUrl = `${BASE_URL}V2/Places/GetLocations?${queryString.length > 0 ? queryString.join("&") : ""}`;
    const fullUrl = `${BASE_URL}V4/Places/GetLocations?${queryString.length > 0 ? queryString.join("&") : ""}`;

    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json"
        },
        method: "GET"
    };
    var start = new Date();
    //const request = new Request(fullUrl, params);
    return fetch(fullUrl, params).then(response => {
        logAPI("MBHWeb.Api.Search.Locations.Get", start, fullUrl);
        return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.Search.Locations.Get.Failure", start, fullUrl, err); return Promise.reject(err); });
};


/**
 * Phynd v2 GetLocationTypes.
 * 
 * @param {any} searchModel Search parameters; property names must match the phynd api.
 * @returns {Promise} location type results.
 */
export const getLocationTypes = (searchModel) => {
    const fullUrl = encodeURI(`${BASE_URL}v2/Location/GetLocationTypes?networkCode=${searchModel.networkCode}&AddAll=${searchModel.AddAll}&lob=${searchModel.lob}`);
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json"
        },
        method: "GET"
    };
    var start = new Date();
    //const request = new Request(fullUrl, params);
    return fetch(fullUrl, params).then(response => {
        logAPI("MBHWeb.Api.Search.Locations.GetTypes", start, fullUrl);
        return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.Search.Locations.GetTypes.Failure", start, url, err); return Promise.reject(err); });
};


/**
 * Phynd v2 GetMappedFacilityTypes.
 * 
 * @param {any} searchModel Search parameters; property names must match the phynd api.
 * @returns {Promise} facility type results.
 */
export const getMappedFacilityTypes = (searchModel) => {
    const fullUrl = encodeURI(`${BASE_URL}v2/Location/GetMappedFacilityTypes?AddAll=${searchModel.AddAll}&lob=${searchModel.lob}`);
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json"
        },
        method: "GET"
    };
    var start = new Date();
    //const request = new Request(fullUrl, params);
    return fetch(fullUrl, params).then(response => {
        logAPI("MBHWeb.Api.Search.Locations.GetMappedFacilityTypes", start, fullUrl);
        return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.Search.Locations.GetMappedFacilityTypes.Failure", start, url, err); return Promise.reject(err); });
};
